import { Tag } from "primereact/tag";
import { InspectionStatus } from "../../types/inspection";

type Props = {
    status: string | null;
}

export const InspectionStatusTag = (props: Props) => {
    const { status } = props;

    const getStatusSeverity = () => {
        switch (status) {
            case InspectionStatus.NEW:
            case InspectionStatus.BIDDING:
            case InspectionStatus.UPCOMING:
            case InspectionStatus.INSPECTION_COMPLETED:
                return "info";
            case InspectionStatus.CONFIRMED:
            case InspectionStatus.FULL_REPORT:
                return "success";
            case InspectionStatus.CANCELLED:
                return "danger";
            case InspectionStatus.COMMENCED:
                return "warning";
            case InspectionStatus.HOLD:
                return "danger";
            default:
                return "info"; // Default case for unexpected values
        }
    };

    const getStatusLabel = () => {
        const matchingStatus = Object.values(InspectionStatus).find((inspectionStatus) => inspectionStatus === status);

        if (matchingStatus) {
            return matchingStatus.replace("_", " ");
        }

        return "Unknown Status";
    };

    return <Tag value={getStatusLabel()} severity={getStatusSeverity()} />;
};
